import React, { useState, useEffect } from "react";
import { createPortal } from "react-dom";
import "../../styles/common/popup.scss";

const CreatePagePopup = ({
  open,
  handleClose,
  title = "Create Page",
  headerTitle,
  buttonText = "Create",
  initialValue = "",
  initialType = "",
}) => {
  const [name, setName] = useState("");
  const [type, setType] = useState("");

  const isSaveDisabled = !name.trim() || !type;

  const handleSave = () => {
    handleClose();
  };

  const pageTypes = [
    "Content",
    "MCQ",
    "Exam",
    "Adaptive Learning",
    "Related Videos",
    // "Active Recall",
  ];

  useEffect(() => {
    if (open) {
      setName(initialValue || "");
      setType(initialType || "");
    }
  }, [open, initialValue, initialType]);
  return createPortal(
    <div
      className={`common-popup-overlay ${open ? "" : "hidden"} high-z-index`}
      onClick={handleClose}
    >
      <div
        className="common-popup-container"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="popup-header">
          <h2>{headerTitle || title}</h2>
          <button className="popup-close-button" onClick={handleClose}>
            ×
          </button>
        </div>

        <div className="popup-content">
          <form
            onSubmit={(e) => {
              e.preventDefault();
              handleSave();
            }}
          >
            <div className="popup-form-group">
              <label htmlFor="page-name">Name of the page</label>
              <input
                id="page-name"
                type="text"
                className="popup-input"
                placeholder="Name"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </div>

            <div className="popup-form-group">
              <label htmlFor="page-type">Type</label>
              <select
                id="page-type"
                className="popup-select"
                value={type}
                onChange={(e) => setType(e.target.value)}
              >
                <option value="">Select a type</option>
                {pageTypes.map((option) => (
                  <option key={option} value={option}>
                    {option}
                  </option>
                ))}
              </select>
            </div>

            <div className="popup-actions">
              <button
                type="submit"
                className="popup-submit-button"
                disabled={isSaveDisabled}
              >
                {buttonText}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default CreatePagePopup;
